'use client';

import Script from 'next/script';
import { useDealershipConfiguration } from '~/context/dealership/StaticContext';

export default function DealerDotComScript() {
  const { dealerDotComCode } = useDealershipConfiguration();

  return dealerDotComCode ? (
    <Script
      strategy="afterInteractive"
      src={`https://assets.prod.analytics.dealer.com/pix-aop-auto.js?dealerCode=${dealerDotComCode}`}
    />
  ) : null;
}
